import { useMemo, useState } from 'react';
import { PageHeader } from '../components/PageHeader';
import { ScoreBadge } from '../components/ScoreBadge';
import { calculateOrchestrationScore } from '../lib/scoring';

export function CreateScorePage() {
  const [metrics, setMetrics] = useState({
    reliability: 80,
    taskFit: 78,
    toolCompatibility: 76,
    costEfficiency: 82,
    evidenceQuality: 74
  });
  const score = useMemo(() => calculateOrchestrationScore(metrics), [metrics]);

  return (
    <section className="page">
      <PageHeader title="Create orchestration score" description="First-pass modular evaluator. Later replacement can call an LLM evaluator behind the same interface." />
      <div className="grid cols-2">
        <form className="card form-grid">
          {Object.entries(metrics).map(([key, value]) => (
            <label key={key}>
              {key}
              <input
                min="0"
                max="100"
                type="number"
                value={value}
                onChange={(event) => setMetrics((current) => ({ ...current, [key]: Number(event.target.value) }))}
              />
            </label>
          ))}
        </form>
        <div className="card">
          <h2 className="section-title">Calculated score</h2>
          <p className="muted">reliability * 0.3 + taskFit * 0.25 + toolCompatibility * 0.2 + costEfficiency * 0.15 + evidenceQuality * 0.1</p>
          <ScoreBadge score={score} />
        </div>
      </div>
    </section>
  );
}
